import classNames from 'classnames';
import React, { FC } from 'react';

import Button from '../UI/button/Button';
import NextLink from '../UI/nextLink/NextLink';
import SaleUnion from '../UI/saleUnion/SaleUnion';

import styles from './ButtonsGroup.module.scss';

type TBtns = {
    price: number;
    purchaseUrl: string;
    preview: string;
    title: string;
};

const ButtonsGroup: FC<TBtns> = ({ preview, price, title, purchaseUrl }) => {
    return (
        <div className={styles.buttons}>
            <div className={styles.top}>
                <Button
                    target
                    buttonUrl={purchaseUrl}
                    ariaLabelledby="buttons-group-preview"
                    color="accent__divided">
                    <span id="buttons-group-preview">Purchase Now</span> <span>${price}</span>
                </Button>
                <Button
                    ariaLabel={`Preview ${title}`}
                    buttonUrl={preview ?? ''}
                    color="standard"
                    target>
                    <span>Preview {title}</span>
                    <svg
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none">
                        <path
                            d="M6.43674 5.19931L12.7123 5.28769M12.7123 5.28769L12.8007 11.5633M12.7123 5.28769L5.28769 12.7123"
                            stroke="#0A163C"
                            strokeWidth="1.7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </Button>
            </div>
            <div className={styles.divider}>
                <span className={styles.line}></span>
                <span className={styles.letter}>or</span>
                <span className={styles.line}></span>
            </div>
            <div className={styles.special}>
                <span className={classNames(styles.special__text, 'caveat')}>
                    Limited Offer
                    <svg viewBox="0 0 41 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            width="41"
                            height="35"
                            d="M1.74587 1.48694C0.863602 6.25999 1.81449 12.857 5.85758 18.5874C9.90066 24.3178 18.5734 26.8989 27.1262 27.7154C31.1942 28.1037 34.8488 27.6155 38.8168 27.4972C41.4851 27.4177 36.0504 29.2832 35.5299 29.4876C33.0258 30.4704 26.0972 34.2627 28.4478 33.0592C31.6194 31.4353 34.9408 30.0732 38.2068 28.5878C40.8805 27.3719 38.7942 28.0261 36.5125 26.7066C34.9979 25.8307 32.197 24.1729 32.8529 22.5896"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                    </svg>
                </span>
                <NextLink
                    ariaLabel="Purchase All Themes"
                    href="/bundle"
                    className={styles.bundle}
                    ariaLabelledby="buttons-group-purchase">
                    <span id="buttons-group-purchase" className={styles.bundle__text}>
                        Purchase All Themes
                    </span>
                    <SaleUnion color="highlight" />
                </NextLink>
            </div>
        </div>
    );
};

export default ButtonsGroup;
